import { theme, setDefault } from '../../styles/theme';
import { css } from '@emotion/css';
import '../../styles/global';
import { deepDefaults } from '../../styles/utils';
import { cache } from '../utils';
var defaults = {
  title: {
    fontSize: '14px',
    gap: '8px',
    fontWeight: '500'
  },
  get color() {
    return theme.color.text;
  },
  get padding() {
    return "6px " + theme.default.padding;
  }
};
var tip;
setDefault(function () {
  tip = deepDefaults(theme, {
    tip: defaults
  }).tip;
  makeStyles == null || makeStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("&.", k, "-tip{display:flex;height:auto;padding:0;color:", tip.color, "!important;align-items:flex-start;}.", k, "-tip-wrapper{flex:1;padding:", tip.padding, ";}.", k, "-tip-title{font-size:", tip.title.fontSize, ";margin-bottom:", tip.title.gap, ";font-weight:", tip.title.fontWeight, ";}&.", k, "-fade-leave-active{position:relative;}.", k, "-tip-close:hover{background:none;}");
});